"use client";

import { Grid } from "@tremor/react";
import { useSelector } from 'react-redux';
import { Skeleton } from "@mui/material";
import ComparativeCardKpi from "../component/comparativeCardKpi";
import ListProgressBar from "../component/listProgressBar";
import { isLoading } from "../component/loading/store";
import {
    CumulativeOrderIntegrationPendingImportByUnidadeKPI,
    OrderIntegrationPendingImportCountKPI,
    OrderIntegrationPendingImportValueKPI,
} from "./helper";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function OrderIntegration() {
    const kpiOrderIntegration = useSelector((state) => state.kpiOrderIntegration)
    const loadingOrderIntegration = useSelector((state) => isLoading(state, 'KPI_ORDER_INTEGRATION'))

    // faz o filtro das listas de integracoes por marca selecionada pelo usuário
    const filteredKpiOrderIntegration = useTrademarkFilter(kpiOrderIntegration)

    const cardOrderIntegrationPendingImportCountKPI = OrderIntegrationPendingImportCountKPI(filteredKpiOrderIntegration)
    const cardOrderIntegrationPendingImportValueKPI = OrderIntegrationPendingImportValueKPI(filteredKpiOrderIntegration)
    const cardCumulativeOrderIntegrationPendingImportByUnidadeKPI = CumulativeOrderIntegrationPendingImportByUnidadeKPI(filteredKpiOrderIntegration)

    return (
        <>
            <Grid numItemsSm={1} numItemsMd={2} numItemsLg={2} className="gap-6 mt-6">
                {!loadingOrderIntegration ? (
                    <>
                        <ComparativeCardKpi {...cardOrderIntegrationPendingImportCountKPI} />
                        <ComparativeCardKpi {...cardOrderIntegrationPendingImportValueKPI} />
                    </>
                ) : (
                    <>
                        <Skeleton variant="rounded" height={300} />
                        <Skeleton variant="rounded" height={300} />
                    </>
                )}
            </Grid>

            <div className="mt-6">
                <Grid numItemsSm={1} numItemsMd={1} numItemsLg={1} className="gap-6 mt-6">
                    {!loadingOrderIntegration ? (
                        <ListProgressBar {...cardCumulativeOrderIntegrationPendingImportByUnidadeKPI} />
                    ) : (
                        <Skeleton variant="rounded" height={300} />
                    )}
                </Grid>
            </div>
        </>
    );
}
